import { Box } from '@chakra-ui/react';
import React from 'react';

const FacebookIcon = () => {
    return (
        <Box>
            <svg
                xmlns='http://www.w3.org/2000/svg'
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
                stroke='currentColor'
                stroke-width='2'
                stroke-linecap='round'
                stroke-linejoin='round'
                class='lucide lucide-facebook w-5 h-5 text-black-600'
                data-id='22'
            >
                <path d='M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z'></path>
            </svg>
        </Box>
    );
};

export default FacebookIcon;
